<template>
  <div
    class="acl-inbox-view-conversation-header acl-inbox-list-header relative z-30 flex h-16 w-full items-center justify-between gap-2 border-b border-n-weak bg-n-surface-1 px-4 md:px-5"
  >
    <div class="flex items-center gap-2 min-w-0 flex-1">
      <span
        class="i-lucide-inbox size-5 flex-shrink-0 text-[#15603e] dark:text-[#86efac]"
        aria-hidden="true"
      />
      <h1
        class="acl-inbox-list-title truncate text-xl font-semibold leading-tight text-n-slate-12"
      >
        {{ $t('INBOX.LIST.TITLE') }}
      </h1>
    </div>
    <div
      class="acl-mobile-account-menu-host relative flex items-center gap-1"
    />
  </div>
</template>
